// custom dispatch object to allow dispatch outside react components
export const customDispatch = {
  dispatch: null,
};
